import { webapi, ErrorParse } from './webapi';

const CreateMobileCheckout = async (data, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        const response = await webapi.post('/api/mobilecheckout/create', data);
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

const GetMobileCheckout = async (checkoutId, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        const response = await webapi.get(`/api/mobilecheckout/${checkoutId}`);
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

const PayWithPhonePe = async (checkoutId, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        const response = await webapi.post(`/api/mobilecheckout/${checkoutId}/phonepe`);
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

const PayWithStripe = async (checkoutId, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        const response = await webapi.post(`/api/mobilecheckout/${checkoutId}/stripe`);
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

const CompleteMobileCheckout = async (checkoutId, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        //const response = await webapi.post(`/api/mobilecheckout/${checkoutId}/complete`);
        const response = await webapi.post(
            `/api/mobilecheckout/${checkoutId}/complete`, 
            {} 
        );
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

const CancelMobileCheckout = async (checkoutId, callbacks) => {
    const { onSuccess, onError } = callbacks;
    try {
        // response = await webapi.post(`/api/mobilecheckout/${checkoutId}/cancel`);
        const response = await webapi.post(
            `/api/mobilecheckout/${checkoutId}/cancel`, 
            {} 
        );
        onSuccess(response.data);
    } catch (error) {
        onError(ErrorParse(error));
    }
};

export {
    CreateMobileCheckout,
    GetMobileCheckout,
    PayWithPhonePe,
    PayWithStripe,
    CompleteMobileCheckout,
    CancelMobileCheckout
};